import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { faCogs, faUsers } from "@fortawesome/free-solid-svg-icons";

@Component({
    selector: 'app-admin-panel',
    templateUrl: './admin-panel.component.html',
    styleUrls: ['./admin-panel.component.scss']
})
export class AdminPanelComponent {
    usersIcon = faUsers;
    gearIcon = faCogs;

    constructor(
        private router: Router
      ) {}
  
  
    goToUsers() {
        this.router.navigate(['/admin/users']);
    }

    goToSettings() {
        this.router.navigate(['/admin/settings']);
    }
}